export default __webpack_public_path__ + "static/media/background.446b7b57.png";